'use client';

import { ErrorPage } from '@/shared/ui/ErrorPage';

export default ErrorPage;
